import { TableCell, TableSortLabel, TableRow } from "@material-ui/core";
import { omit } from "lodash";
import styled, { css } from "styled-components";
import { colours } from "../../styles/colours";
import { hiddenMobile } from "../layout";

export namespace StyledTable {
  export const Cell = styled((props) => (
    <TableCell {...omit(props, "noPadding", "hiddenMobile")} />
  ))<{ noPadding?: boolean; hiddenMobile: boolean }>`
    ${(props) => (props.noPadding ? "padding: 0" : "")};
    ${(props) => (props.hiddenMobile ? hiddenMobile : "")};
  `;

  const HeaderCell = css`
    border-bottom: 2px solid ${colours.lightGrey};
    padding: 1em;
    padding-bottom: 0.5em;
    margin-bottom: 0.5em;
    display: block;
  `;

  export const StyledSortLabel = styled(TableSortLabel)`
    ${HeaderCell}
  `;
  export const StyledLabel = styled.span`
    ${HeaderCell}
  `;

  export const StyledCell = styled(StyledSortLabel).attrs({ as: TableCell })``;

  export const Row = styled((props) => <TableRow {...omit(props, "even")} />)<{
    even: boolean;
  }>`
    :nth-child(${(props) => (props.even ? "2n" : "2n - 1")}) ${Cell} {
      background: ${colours.lightPurple};
    }

    ${(props) => (props.onClick ? "cursor: pointer" : "")};
  `;
}
